a<div fxLayout="column">

  <div class="editSets">
    <div class="title-head3" color="primary">
      <span>Image</span>
    </div>
    <div id="responsieTable" class="container" style="overflow-x:auto;">
      <table class="rwd-table">
        <tbody>
          <tr>
            <th>Image</th>
            <th>Action</th>
          </tr>
          <ng-container>
            <tr *ngFor="let images of imageList; let k = index">
              <td data-th="Image" style="width: 60%;">
                <!-- <img style="height: 65px;width: auto;" [src]="serverPath + images.imageName"
                    onerror="this.src='assets/images/no-image.png';" alt=""> -->

                <calsoft-common-images [src]="serverPath + images.imageName" [height]="'65px'" [width]="'auto'">

                </calsoft-common-images>
              </td>
              <td data-th="Action">
                <button [attr.guide]="'multiple-images-btn-1' + '__' + sanitizeUrl(url)" color="warn" mat-icon-button type="button" (click)="deleteImage(images.imageName,k)">
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>


</div>

<div>
  <calsoft-common-file-upload (fileUploadResult)="getResult($event)" [type]="'gallery'"></calsoft-common-file-upload>
</div>